import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableContainer,
  TableHead,
  TableRow,
  Dialog, // Import Dialog component
  DialogTitle, // Import DialogTitle for the header
  DialogContent, // Import DialogContent for the body
  Button, // Import Button for the submit button
  Select, // Import Select for dropdowns
  MenuItem, // Import MenuItem for dropdown options
  TextField, // Import TextField for the quantity input
  FormControl, // Import FormControl for better form control
  InputLabel,
  Modal,
  Typography,
  IconButton,
  Box,
  Stack, // Import InputLabel for the dropdown labels
} from "@mui/material";
import "./SFGstore.css";
import COCDatePicker from "../../components/DateTimePicker/DateTimePicker";
import dayjs from "dayjs";
import SearchIcon from "@mui/icons-material/Search";
import {
  getSFGInventoryDetails,
  getSFGStoreDetails,
  retriveSFGBoxGloves,
} from "./services";
import CloseIcon from "@mui/icons-material/Close";
import { getClasses, getSizes } from "../AddBatch/services";
import "./SFGstore.css";
import {
  getcuff,
  getPairingGlovesType,
  getParingLength,
} from "../GlovesPairing/services";
import { toast, ToastContainer } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";

const SFGInventoryTable = () => {
  const navigate = useNavigate();
  const [showTime, setShowTime] = useState(false);
  const [startDateReFormat, setStartDateReFormat] = useState(null);
  const [endDateReFormat, setEndDateReFormat] = useState(null);
  const [debouncedSearchText, setDebouncedSearchText] = useState({});
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [SFGStoreDetails, setSFGStoreDetails] = useState([]);
  const [totalCount, setTotalCount] = useState();
  const [inventoryData, setInventoryData] = useState([]);
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectClass] = useState("");
  const [size, setSize] = useState([]);
  const [selectSize, setSelectSize] = useState("");
  // State to manage the dialog box
  const [openDialog, setOpenDialog] = useState(false);
  const [glovesType, setGlovesType] = useState([]);
  const [selectGlovesType, setSelectGlovesType] = useState("");
  const [GlovesLength, setGlovesLength] = useState([]);
  const [selectGlovesLength, setSelectGlovesLength] = useState("");
  const [cuff, setCuff] = useState([]);
  const [selectCuff, setSelectCuff] = useState("");
  const [quantity, setQuantity] = useState("");
  // New state to track if the filter has been submitted
  const [isFilterSubmitted, setIsFilterSubmitted] = useState(false);

  // New state for confirmation dialog
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [retrievingItem, setRetrievingItem] = useState({
    boxId: null,
    quantity: null,
  });

  const handleClose = () => setOpenDialog(false);

  // New function to handle confirmation before retrieval
  const handleOpenConfirmDialog = (boxId, quantity, box_no,sfg_label) => {
    setRetrievingItem({ boxId, quantity, box_no,sfg_label });
    setOpenConfirmDialog(true);
  };

  const confirmAndRetrieve = async () => {
    try {
      const { boxId } = retrievingItem;
      const params = {
        sfg_box_id: boxId,
        quantity: quantity,
      };
      const response = await retriveSFGBoxGloves(params);
      // Handle the success case (e.g., show a message, refresh the table)
      if (response.data.success) {
        toast.success(response.data.message);
        fetchData(); // Refresh the data to update the table
      }
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      // Close the confirmation dialog
      setOpenConfirmDialog(false);
      setRetrievingItem({ boxId: null, quantity: null });
    }
  };

  // New function to handle form submission
  const handleFilterSubmit = async () => {
    // Collect the selected filter values
    const filterParams = {
      sfg_box_no__class_id__class_name: selectedClass,
      sfg_box_no__size__size_name__icontains: selectSize,
      sfg_box_no__gloves_type__pairing_gloves_type_name__icontains:
        selectGlovesType,
      sfg_box_no__scre_type__cuff_name__icontains: selectCuff,
      sfg_box_no__length__length__icontains: selectGlovesLength,
      page: 1, // Reset to the first page for new filters
      page_size: rowsPerPage,
    };

    // Filter out any empty values to avoid sending unnecessary query parameters
    const filteredParams = Object.fromEntries(
      Object.entries(filterParams).filter(([_, value]) => value !== "")
    );

    // Call the API with the new filter parameters
    try {
      const response = await getSFGInventoryDetails(filteredParams);
      if (response.data.results.success === true) {
        setInventoryData(response.data.results.payload);
        setTotalCount(response.data.count);
        setIsFilterSubmitted(true); // Set state to true on successful submission
      } else {
        setInventoryData([]);
        setTotalCount(0);
        setIsFilterSubmitted(false);
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
      setInventoryData([]);
      setTotalCount(0);
      setIsFilterSubmitted(false);
    }

    // Close the modal after submitting
    handleClose();
  };

  // Style for the main modal box
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "90%", sm: 450 }, // Responsive width
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    overflow: "hidden", // Ensures rounded corners on the header
  };

  const headerStyle = {
    bgcolor: "#1C3669", // Dark blue background color
    color: "white",
    p: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };
  const submitButtonStyle = {
    bgcolor: "#1C3669",
    "&:hover": {
      bgcolor: "#142a54",
    },
    color: "white",
    fontWeight: "bold",
    py: 1.5,
    borderRadius: 1,
    width: "100%",
  };
  const formFieldStyle = {
    mb: 3,
  };

  const handleToggleTime = () => {
    setShowTime(!showTime);
  };

  const handleStartDate = (newStartDate) => {
    if (showTime) {
      setStartDateReFormat(newStartDate);
    } else {
      setStartDateReFormat(dayjs(newStartDate).hour(0).minute(0).second(0));
    }
  };

  const handleEndDate = (newEndDate) => {
    if (showTime) {
      setEndDateReFormat(newEndDate);
    } else {
      setEndDateReFormat(dayjs(newEndDate).hour(23).minute(59).second(59));
    }
  };

  // Updated initial values to match API filter parameters
  const initiallValue = {
    sfg_box_no__box_no__icontains: "",
    created_at: "",
    sfg_box_no__gloves_type__pairing_gloves_type_name__icontains: "",
    sfg_box_no__class_id__class_name: "",
    sfg_box_no__size__size_name__icontains: "",
    sfg_box_no__length__length__icontains: "",
    sfg_box_no__scre_type__cuff_name__icontains: "",
    sfg_box_no__lot_no__icontains: "",
    quantity__icontains: "",
    rack_id__icontains: "",
    created_by__username__icontains: "",
    sfg_box_no__sfg_label__icontains:""
  };

  const [searchText, setSearchText] = useState(initiallValue);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText); // Update the debounced searchText
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler); // Cleanup the timeout
    };
  }, [searchText]); // Effect runs when searchText changes

  const handleSearchData = (e) => {
    const { name, value } = e.target;
    setSearchText({ ...searchText, [name]: value });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const dateFormat = "YYYY-MM-DD HH:mm:ss";
  const formatStartDate = startDateReFormat
    ? dayjs(startDateReFormat).format(dateFormat)
    : "";
  const formatEndDate = endDateReFormat
    ? dayjs(endDateReFormat).format(dateFormat)
    : "";
  useEffect(() => {
    getData();
    return () => {};
  }, []);
  const getData = async () => {
    try {
      const resp = await getClasses();
      setClasses(resp.data.payload);
      const resp3 = await getSizes();
      setSize(resp3.data.payload);
      const resp4 = await getcuff();
      setCuff(resp4.data);
      // Call the getPairingGlovesType API endpoint and set the glovesType state
      const resp1 = await getPairingGlovesType();
      setGlovesType(resp1.data);
      // Call the getParingLength API endpoint and set the glovesLength state
      const resp2 = await getParingLength();
      setGlovesLength(resp2.data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchData = async () => {
    // Constructing the search parameters to match the API
    const searchParams = {
      ...debouncedSearchText, // Spread the debounced search filters
      page: page + 1,
      page_size: rowsPerPage,
      start_datetime: formatStartDate,
      end_datetime: formatEndDate,
    };

    // Filter out empty or undefined values before making the request
    const filteredSearchParams = Object.fromEntries(
      Object.entries(searchParams).filter(([_, value]) => value !== "")
    );
    try {
      const response = await getSFGInventoryDetails(filteredSearchParams);
      if (response.data.results.success === true) {
        setInventoryData(response.data.results.payload);
        setTotalCount(response.data.count);
      }
    } catch (error) {
      setInventoryData([]);
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [debouncedSearchText, page, rowsPerPage, formatStartDate, formatEndDate]);

  // Handle dialog open
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  return (
    <>
      <ToastContainer />
      <div className="dashboard-wrapper page-wraper">
        <div className="page-header">
          <div
            className="page-back-btn"
            onClick={() => navigate("/SFG-store")}
            style={{ cursor: "pointer" }}
          >
            <ArrowBackIcon />
            <span>SFG Inventory Dashboard</span>
          </div>
          {/* Attach the onClick handler to the button */}
          <div className="d-flex gap-2">
            <button
              className="PackDispatch-page-header-btn"
              onClick={() => navigate("/retrive-history")}
            >
              Retrive History
            </button>
            <button
              className={`PackDispatch-page-header-btn ${
                isFilterSubmitted ? "" : "blue-button"
              }`}
              onClick={handleOpenDialog}
            >
              Retrive
            </button>
          </div>
        </div>
        <div className="pt-3 table-responsive">
          <TableContainer component={Paper}>
            <Table
              aria-label="Dipping parameter"
              className="dipping-params sfg-score-table"
            >
              <TableHead>
                <TableRow>
                  <TableCell>Label No.</TableCell>
                  <TableCell>Date and Time</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Class</TableCell>
                  <TableCell>Size</TableCell>
                  <TableCell>Length</TableCell>
                  <TableCell>Cuff</TableCell>
                  <TableCell>Lot No</TableCell>
                  <TableCell>Quantity</TableCell>
                  <TableCell>Box No.</TableCell>
                  <TableCell>Rack Id</TableCell>
                  <TableCell>User</TableCell>
                  <TableCell>Retrive</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Label No."
                      name="sfg_box_no__box_no__icontains"
                      value={searchText.sfg_box_no__box_no__icontains}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Date and Time"
                      name="created_at"
                      value={searchText.created_at}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Type"
                      name="sfg_box_no__gloves_type__pairing_gloves_type_name__icontains"
                      value={
                        searchText.sfg_box_no__gloves_type__pairing_gloves_type_name__icontains
                      }
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Class"
                      name="sfg_box_no__class_id__class_name"
                      value={searchText.sfg_box_no__class_id__class_name}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="size"
                      name="sfg_box_no__size__size_name__icontains"
                      value={searchText.sfg_box_no__size__size_name__icontains}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Length"
                      name="sfg_box_no__length__length__icontains"
                      value={
                        searchText.sfg_box_no__length__length__icontains
                      }
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Cuff"
                      name="sfg_box_no__scre_type__cuff_name__icontains"
                      value={
                        searchText.sfg_box_no__scre_type__cuff_name__icontains
                      }
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Lot No"
                      name="sfg_box_no__lot_no__icontains"
                      value={searchText.sfg_box_no__lot_no__icontains}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Quantity"
                      name="quantity__icontains"
                      value={searchText.quantity__icontains}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Box No."
                      name="sfg_box_no__sfg_label__icontains"
                      value={searchText.sfg_box_no__sfg_label__icontains}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Rack Id"
                      name="rack_id__icontains"
                      value={searchText.rack_id__icontains}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="User"
                      name="created_by__username__icontains"
                      value={searchText.created_by__username__icontains}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Retrive"
                      name=""
                      value=""
                      onChange={() => {}}
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Dynamically render table rows from inventoryData */}
                {inventoryData && inventoryData.length > 0 ? (
                  inventoryData.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.box_no}</TableCell>
                      <TableCell>
                        {item.created_at
                          ? dayjs(item.created_at).format("YYYY-MM-DD HH:mm:ss")
                          : ""}
                      </TableCell>
                      <TableCell>{item.gloves_type}</TableCell>
                      <TableCell>{item.class_name}</TableCell>
                      <TableCell>{item.size_name}</TableCell>
                      <TableCell>{item.length}</TableCell>
                      <TableCell>{item.cuff}</TableCell>
                      <TableCell>{item.lot_no}</TableCell>
                      <TableCell>{item.quantity}</TableCell>
                      <TableCell>{item.sfg_label}</TableCell>
                      <TableCell>{item.rack_id}</TableCell>
                      <TableCell>{item.created_by}</TableCell>
                      <TableCell>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <button
                            className={`retrive-btn ${
                              isFilterSubmitted ? "blue-button" : ""
                            }`}
                            onClick={() =>
                              handleOpenConfirmDialog(
                                item.id,
                                item.quantity,
                                item.box_no,
                                item.sfg_label
                              )
                            }
                            disabled={!isFilterSubmitted}
                          >
                            Retrive
                          </button>

                          <VisibilityIcon
                            style={{ cursor: "pointer", color: "#555" }}
                            onClick={() => navigate(`/view-history/${item.id}`)}
                          />
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={13} align="center">
                      No data found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <TablePagination
          className="table-pagination"
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={totalCount || 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        {/* The Dialog component */}
        <Modal
          open={openDialog}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modalStyle}>
            {/* Modal Header */}
            <Box sx={headerStyle}>
              {/* Centered Typography using absolute positioning */}
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{
                  color: "white",
                  position: "absolute",
                  left: "50%",
                  top: "6%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                SFG RETRIVAL
              </Typography>
              {/* IconButton on the far right */}
              <IconButton
                onClick={handleClose}
                sx={{ color: "white", ml: "auto" }} // Pushes the button to the right
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Modal Body with Form */}
            <Box sx={{ p: 4 }}>
              <Typography sx={{ mb: 2, fontWeight: "medium" }}>
                Select the options below
              </Typography>

              <Stack spacing={2}>
                {/* Class Dropdown */}
                <FormControl fullWidth sx={formFieldStyle}>
                  <InputLabel id="class-label">Class</InputLabel>
                  <Select
                    labelId="class-label"
                    id="class-select"
                    label="Class"
                    value={selectedClass}
                    onChange={(event) => setSelectClass(event.target.value)}
                  >
                    {classes ? (
                      classes.map((event) => (
                        <MenuItem value={event.class_name}>
                          {event.class_name}
                        </MenuItem>
                      ))
                    ) : (
                      <option>{"No Data Found"}</option>
                    )}
                  </Select>
                </FormControl>

                {/* Size Dropdown */}
                <FormControl fullWidth sx={formFieldStyle}>
                  <InputLabel id="size-label">Size</InputLabel>
                  <Select
                    labelId="size-label"
                    id="size-select"
                    label="Size"
                    value={selectSize}
                    onChange={(event) => setSelectSize(event.target.value)}
                  >
                    {size ? (
                      size.map((event) => (
                        <MenuItem value={event.size_name}>
                          {event.size_name}
                        </MenuItem>
                      ))
                    ) : (
                      <option>{"No Data Found"}</option>
                    )}
                  </Select>
                </FormControl>

                {/* Gloves Type Dropdown */}
                <FormControl fullWidth sx={formFieldStyle}>
                  <InputLabel id="gloves-type-label">Gloves Type</InputLabel>
                  <Select
                    labelId="gloves-type-label"
                    id="gloves-type-select"
                    label="Gloves Type"
                    value={selectGlovesType}
                    onChange={(event) =>
                      setSelectGlovesType(event.target.value)
                    }
                  >
                   
                    <MenuItem value="Insulating">Insulating</MenuItem>
                    <MenuItem value="Composite">Composite</MenuItem>
                  </Select>
                </FormControl>

                {/* Cuff Dropdown */}
                <FormControl fullWidth sx={formFieldStyle}>
                  <InputLabel id="cuff-label">Cuff</InputLabel>
                  <Select
                    labelId="cuff-label"
                    id="cuff-select"
                    label="Cuff"
                    value={selectCuff}
                    onChange={(event) => setSelectCuff(event.target.value)}
                  >
                    {cuff ? (
                      cuff.map((element) => (
                        <MenuItem value={element.cuff_name}>
                          {" "}
                          {element.cuff_name}
                        </MenuItem>
                      ))
                    ) : (
                      <option>{"No Data Found"}</option>
                    )}
                  </Select>
                </FormControl>

                {/* Length Dropdown */}
                <FormControl fullWidth sx={formFieldStyle}>
                  <InputLabel id="length-label">Length</InputLabel>
                  <Select
                    labelId="length-label"
                    id="length-select"
                    label="Length"
                    value={selectGlovesLength}
                    onChange={(event) =>
                      setSelectGlovesLength(event.target.value)
                    }
                  >
                    {GlovesLength ? (
                      GlovesLength.map((element) => (
                        <MenuItem value={element.length}>
                          {" "}
                          {element.length}
                        </MenuItem>
                      ))
                    ) : (
                      <option>{"No Data Found"}</option>
                    )}
                  </Select>
                </FormControl>

                {/* Quantity Input */}
                <TextField
                  fullWidth
                  label="Quantity"
                  type="number"
                  placeholder="Type-in required quantity"
                  sx={{ mb: 4 }}
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                />

                {/* Submit Button */}
                <Button
                  variant="contained"
                  onClick={handleFilterSubmit}
                  sx={submitButtonStyle}
                >
                  Submit
                </Button>
              </Stack>
            </Box>
          </Box>
        </Modal>

        {/* Confirmation Dialog for Retrieval */}
        <Modal
          open={openConfirmDialog}
          onClose={() => setOpenConfirmDialog(false)}
          aria-labelledby="confirm-modal-title"
          aria-describedby="confirm-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: 400 },
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 4,
              textAlign: "center",
            }}
          >
            <Typography
              id="confirm-modal-title"
              variant="h6"
              component="h2"
              sx={{ mb: 2 }}
            >
              Confirm Retrieval
            </Typography>
            <Typography id="confirm-modal-description" sx={{ mb: 3 }}>
              You are about to retrieve {quantity} quantity from this box number{" "}
              {retrievingItem.sfg_label}.
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="center">
              <Button
                variant="outlined"
                className="confirm-retrive"
                onClick={() => setOpenConfirmDialog(false)}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={submitButtonStyle}
                onClick={confirmAndRetrieve}
              >
                Confirm
              </Button>
            </Stack>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default SFGInventoryTable;